/* eslint-disable default-case */
import {
//Editor Available states below
CLAIMED_FOR_RESPONSE, CLAIMED_FOR_REVIEW, CLAIMED_FOR_FORWARD_REVIEW, DISAGREED, CLAIMED_CLIENT_ACTION,
//Read Only States below
RESPOND, RESPOND_CLIENT_ACTION, REVIEW, REPORTED, PASSED, CLAIM_TIMEOUT, SILENT_CLAIM_TIMEOUT, CLOSED, BLANK, CLAIMED_BY_ANOTHER, FORWARDED, RESPONDED, REVIEWED, isMessageEditorState, isReadOnlyState, isMessageReviewState, VIEW_AS_MANAGER, RESPOND_AS_MANAGER, CLAIMED_FOR_RESPONSE_DURING_REVIEW, REVIEW_DETAILED, CLAIMED_FOR_REVIEW_DETAILED, DETAILED_REVIEW_AS_MANAGER, QUALITY_REVIEW_AS_MANAGER } from "../message-state-constants/MessageStateConstants";
import { doesUserHavePolicy, getCustomerData } from "../..";
import { log as pilog, ClientContext, getLastDialogue } from "@limitless/common/utils";
import { getPreviewActions } from "../MessageEditorPreviewActionsMapper";
import { POLICY_SENSITIVE_DATA_REQUEST_ACCESS, POLICY_SENSITIVE_DATA_VIEW_ACCESS } from "..";
const VALID_FOOTER_STATES = {
  [CLOSED]: CLOSED,
  [REPORTED]: REPORTED,
  [CLAIM_TIMEOUT]: CLAIM_TIMEOUT,
  [CLAIMED_BY_ANOTHER]: CLAIMED_BY_ANOTHER,
  [SILENT_CLAIM_TIMEOUT]: SILENT_CLAIM_TIMEOUT
};

/**
 * Takes the profile and a message and calculates the UI state
 *
 * @param {object} profile
 * @param {object} inputMessage
 */
export const calculateMessageState = (profile, inputMessage, messageResources, nextStateOverride, extraEngine) => {
  var _message$conversation, _message$dialogues;
  const INITIAL_CONVERSATION_STATE = {
    conversationState: {
      state: BLANK,
      showExpertRating: false,
      showExpertThumbnail: false
    }
  };
  const log = pilog.getLogger("MessageStateEngine calculateMessageState");
  log.debug("Calculating Message State");
  log.debug(`Next State Override: ${nextStateOverride}`);
  log.debug(messageResources);
  let previousState = BLANK;
  if (inputMessage.conversationState) {
    previousState = inputMessage.conversationState.state;
  }
  //clone the message
  const message = {
    ...INITIAL_CONVERSATION_STATE,
    ...inputMessage
  };

  //could be useful & it was :)
  message.conversationState.previousState = previousState;
  message.conversationState.previousDialogueCount = (_message$conversation = message.conversationState) === null || _message$conversation === void 0 ? void 0 : _message$conversation.dialogueCount;
  message.conversationState.dialogueCount = (_message$dialogues = message.dialogues) === null || _message$dialogues === void 0 ? void 0 : _message$dialogues.length;
  const isCrowdManager = doesUserHavePolicy("app_access_cm", profile) && ClientContext._appName === "crowd_manager";
  if (process.env.REACT_APP_NAME === "ExpertWebApp" || process.env.REACT_APP_NAME === "ExpertMobileApp") {
    if (message !== null && message !== void 0 && message.secureDataEnabled) {
      getCustomerData(message, profile, secureData => {
        var _secureData$data;
        message.conversationState.secureData = (_secureData$data = secureData.data) !== null && _secureData$data !== void 0 ? _secureData$data : [];
      });
    }
  } else {
    getCustomerData(message, profile, secureData => {
      var _secureData$data2;
      message.conversationState.secureData = (_secureData$data2 = secureData.data) !== null && _secureData$data2 !== void 0 ? _secureData$data2 : [];
    });
  }
  calculateOverallMessageState(profile, message, nextStateOverride, isCrowdManager);
  //see if we need to show extra info and get the read only tags
  calculateExtraInfoAndReadOnlyTags(message, messageResources);
  //by default we don't want to allow suggested answers
  message.conversationState.showSuggestedAnswersOptions = false;
  //by default we don't want to allow attachments
  message.conversationState.allowAttachments = false;
  //by default do not override voting logic
  message.conversationState.overrideVoting = false;
  //by default prevent requesting secure data
  message.conversationState.allowSecureDataRequest = false;
  //by default prevent view secure data
  message.conversationState.allowSecureDataView = false;
  // used to indicate whether a message contains a translated dialogue
  message.conversationState.isTranslated = false;
  // Used to show different Panel/Expert Dialogue suffixes - should probably shift to be from state only
  calculateConversationType(message);
  // See if the expert has touched the message
  calculateExpertTouchedMessage(message, profile.userId);
  //only calculate the editor state if it's an editor message
  if (isMessageEditorState(message.conversationState.state) || isMessageReviewState(message.conversationState.state) || isReadOnlyState(message.conversationState.state) || isCrowdManager) {
    try {
      deriveEditorState(message, messageResources, isCrowdManager);
    } catch (error) {
      log.error(`Unable to derive Editor State for ${message.messageId}`, error);
      log.debug(message);
      log.debug(messageResources);
    }
  }
  calculateExpertRatingAndThumbnailState(profile, message);
  calculatePassButtonDisplayRules(message);
  calculateShowCustomerAuthor(message);
  calculateClientActionDialogue(message, nextStateOverride);
  calculateMessageContainsTranslation(message);
  calculateMessageContainsTranslatedLanguage(message);
  calculateAllowSecureDataView(message, profile);
  calculateAllowSecureDataRequest(message, profile);

  //the user is a manager so calculate the manager state
  if (typeof extraEngine === "function") {
    extraEngine(profile, message, messageResources);
  }
  log.debug(`Calculation complete. New state: ${message.conversationState.state} Previous state: ${previousState}`);
  message.lastStateCalculation = new Date().getTime();
  return message;
};

/**
 * If the flo-users.viewRespAuth property value is defined then:
 * it overrides the flo-groups.viewRespAuth (i.e. ignore the flo-groups.viewRespAuth value)
 *
 * @param {object} profile
 * @param {object} message
 */
const calculateExpertRatingAndThumbnailState = (profile, message) => {
  let expertViewRespAuth = profile.viewRespAuth;
  //if the it's not present on the profile, use the message
  if (!expertViewRespAuth || expertViewRespAuth === "postReviewVote") {
    expertViewRespAuth = message.viewRespAuth;
  }
  let showExpertRating = false;
  let showExpertThumbnail = false;
  switch (expertViewRespAuth) {
    case "never":
      showExpertRating = false;
      showExpertThumbnail = false;
      break;
    case "always":
      showExpertRating = true;
      showExpertThumbnail = true;
      break;
    default:
      showExpertRating = false;
      showExpertThumbnail = false;
  }
  message.conversationState.showExpertRating = showExpertRating;
  message.conversationState.showExpertThumbnail = showExpertThumbnail;
};

/**
 * Evaluates the message and calcuates a state value
 *
 * @param {object} profile
 * @param {object} message
 */
const calculateOverallMessageState = (profile, message, nextStateOverride, isCrowdManager) => {
  const log = pilog.getLogger("MessageStateEngine calculateOverallMessageState");
  //if the message has been quarantined, allow no further work, even if a nextStateOverride is passed
  if (message.releaseState === "pending" && !isCrowdManager) {
    log.info("Message is in Quarantined status");
    message.conversationState.state = CLOSED;
    return;
  }

  //if nextStateOverride is present, it should be a valid state
  if (nextStateOverride && (isReadOnlyState(nextStateOverride) || isMessageEditorState(nextStateOverride))) {
    message.conversationState.state = nextStateOverride;
    return;
  }

  //footerState is set by the Web Socket/IoT Actions
  if (message.footerState && message.footerState !== "loading") {
    processFooterState(message);
    return;
  }

  //Crowd Manager won't have an inbox
  if (message.inbox) {
    //a message type should either be 'respond*' or 'review*'
    if (message.inbox.passed) {
      message.conversationState.state = PASSED;
      return;
    } else if (message.inbox.type.includes("respond")) {
      if (isClaimedByThisUser(message)) {
        message.conversationState.state = CLAIMED_FOR_RESPONSE;
      } else {
        message.conversationState.state = RESPOND;
      }
      return;
    } else if (message.inbox.type.includes("review")) {
      if (isClaimedByThisUser(message)) {
        if (message.inbox.type === "review") {
          message.conversationState.state = CLAIMED_FOR_REVIEW;
        } else if (message.inbox.type === "reviewDetailed") {
          message.conversationState.state = CLAIMED_FOR_REVIEW_DETAILED;
        } else {
          message.conversationState.state = CLAIMED_FOR_FORWARD_REVIEW;
        }
      } else {
        //make sure the person looking at the message isn't the person who last added dialogue
        const lastDialogueIndex = message.dialogues.length - 1;
        if (message.dialogues[lastDialogueIndex].userId === profile.userName) {
          message.conversationState.state = CLOSED;
        } else if (message.inbox.type === "reviewDetailed") {
          message.conversationState.state = REVIEW_DETAILED;
        } else {
          message.conversationState.state = REVIEW;
        }
      }
      return;
    }
  }
  if (isCrowdManager) {
    message.conversationState.state = VIEW_AS_MANAGER;
  }
};

/**
 * Ensure the footer state is valid and set the overall conversation state
 *
 * @param {object} message
 */
const processFooterState = message => {
  const log = pilog.getLogger("MessageStateEngine processFooterState");
  const footerState = VALID_FOOTER_STATES[message.footerState];
  if (footerState) {
    message.conversationState.state = footerState;
  } else {
    log.warn(`Invalid footerState ${footerState} detected, defaulting to CLOSED`);
    message.conversationState.state = CLOSED;
  }
};

/**
 * Checks if this message is claimed by the active user
 *
 * @param {object} message
 */
const isClaimedByThisUser = message => {
  if (message.inbox && message.inbox.claimed) {
    return true;
  }
  return false;
};

/**
 * Derives the editor state
 *
 * @param {object} message
 * @param {object} messageResources
 */
const deriveEditorState = (message, messageResources, isCrowdManager) => {
  var _message$inbox;
  const {
    reasonCodes: {
      codes
    }
  } = messageResources;
  calculateMessageContainsTranslation(message);
  calculateMessageContainsTranslatedLanguage(message);
  message.conversationState.showForwardMessageCodes = codes.escalation && codes.escalation.length !== 0;
  message.conversationState.allowReportMessage = true;
  if (message.practiceGroup === true) {
    message.conversationState.allowReportMessage = false;
  }
  //get the Editor State Actions
  message.conversationState.editorState = {
    placeholder: message.conversationState.showTransaltedLanguageText ? "Type to reply. Your responses will be translated to customer’s language" : "Type to reply"
  };

  //don't allow forward if it was a forward review
  if (((_message$inbox = message.inbox) === null || _message$inbox === void 0 ? void 0 : _message$inbox.type) === "reviewEscalation") {
    message.conversationState.showForwardMessageCodes = false;
  }

  //process the various UIControl props
  calculateMessageCodes(message, messageResources);
  calculateMessageTags(message, messageResources);
  calculateDialogueNote(message);
  calculateExpertPrefCapture(message);
  calculateAllowAttachments(message);
  calculateProductCodes(message);
  calculateHideEditor(message);

  //Editor mode, so allow suggested answers options (personalise/dismiss), this is not in the editorState, as the prop is required for read-only too
  message.conversationState.showSuggestedAnswersOptions = true;
  //For now, we always want to preview the response
  message.conversationState.editorState.previewResponse = true;
  //If it's crowd manager, we allow manager feedback
  if (isCrowdManager) {
    message.conversationState.editorState.managerFeedback = true;
  }
  //get the Preview Actions
  message.conversationState.editorState.previewActions = getPreviewActions(message);
  message.conversationState.showClassification = message.conversationState.editorState.previewActions.length !== 0;
  const {
    isMessageCodeMandatory,
    isMessageTagsMandatory,
    isDialogueNoteCaptureMandatory,
    isExpertPrefCaptureMandatory
  } = message.conversationState.editorState;
  message.conversationState.isClassificationMandatory = isMessageCodeMandatory || isMessageTagsMandatory || isDialogueNoteCaptureMandatory || isExpertPrefCaptureMandatory;
  if (message.conversationState.state === DISAGREED && message.reviewRequiredVotingExperts !== 0) {
    message.conversationState.overrideVoting = true;
  }
  //gets mapped to a conversation state value so CM can keep the raw value
  calculateShowCustomerConfirmation(message);
};

/**
 * Calculate where or not we need to capture a response code for this message
 *
 * @param {object} message
 */
export const calculateShowCustomerConfirmation = message => {
  const isLastDialogueCustResolved = message.dialogues.length > 0 && message.dialogues[message.dialogues.length - 1].type === "custResolved";
  message.conversationState.showCustomerConfirmation = false;
  if (![CLAIMED_FOR_FORWARD_REVIEW, DISAGREED].includes(message.conversationState.state)) {
    var _message$inbox2;
    const custConfirmationUIControl = message.custConfirmationUIControl === "never" || message.custConfirmationUIControl === "false" ? false : true;
    if (message.custConfirmationState && (_message$inbox2 = message.inbox) !== null && _message$inbox2 !== void 0 && _message$inbox2.claimed && !message.hasFlaggedConversationComplete && custConfirmationUIControl && !isLastDialogueCustResolved) {
      message.conversationState.showCustomerConfirmation = true;
    }
  }
};

/**
 * Calculate where or not we need to capture a response code for this message
 *
 * @param {object} message
 */
const calculateMessageCodes = (message, messageResources) => {
  const {
    reasonCodes: {
      codes
    }
  } = messageResources;
  let showMessageCodes = false;
  let isMessageCodeMandatory = false;
  switch (message.respCodeUIControl) {
    case "not_req":
      showMessageCodes = false;
      break;
    case "cap_man":
      showMessageCodes = true;
      isMessageCodeMandatory = true;
      break;
    case "cap_opt":
      showMessageCodes = true;
      break;
  }

  //if we don't have any message codes, override platform calculation
  showMessageCodes = codes.response && codes.length !== 0 ? showMessageCodes : false;
  message.conversationState.editorState.showMessageCodes = showMessageCodes;
  message.conversationState.editorState.isMessageCodeMandatory = isMessageCodeMandatory;
};

/**
 * Calculate where or not we need to capture a response code for this message
 *
 * @param {object} message
 */
const calculateMessageTags = (message, messageResources) => {
  const {
    tags
  } = messageResources;
  let showMessageTagsEditor = false;
  let isMessageTagsMandatory = false;
  switch (message.tagUIControl) {
    case "not_req":
      showMessageTagsEditor = false;
      break;
    case "cap_man":
      showMessageTagsEditor = true;
      isMessageTagsMandatory = true;
      break;
    case "cap_opt":
      showMessageTagsEditor = true;
      break;
  }

  //if we don't have any message tags, override platform calculation
  showMessageTagsEditor = tags && tags.length !== 0 ? showMessageTagsEditor : false;
  message.conversationState.editorState.showMessageTagsEditor = showMessageTagsEditor;
  message.conversationState.editorState.isMessageTagsMandatory = isMessageTagsMandatory;
};

/**
 * Checks if the message has tags and sees if they in the tags JSON
 *
 * If they aren't in the JSON, they're read only tags
 *
 * @param {object} message
 * @param {object} messageResources
 */
const calculateExtraInfoAndReadOnlyTags = (message, messageResources) => {
  const log = pilog.getLogger("MessageStateEngine calculateExtraInfoAndReadOnlyTags");
  let showExtraInfo = false;
  let showTagAsResolved = false;

  //this is a special crowd manager menu option - a very specific feature for MS
  if (messageResources.tags.length !== 0) {
    showTagAsResolved = true;
  }
  const readOnlyTags = [];
  const editableTags = [];
  log.debug(message.tags);
  if (message.tags) {
    //TODO remove when LPD-4334 is fixed
    if (message.tags.wrapperName) {
      message.tags = message.tags.values;
    }
    message.tags.map(tag => {
      const tagExistsInResource = messageResources.tags.find(t => t.labelText === tag);
      if (!tagExistsInResource && ![REVIEW_DETAILED, CLAIMED_FOR_REVIEW_DETAILED, DETAILED_REVIEW_AS_MANAGER, QUALITY_REVIEW_AS_MANAGER].includes(message.conversationState.state)) {
        readOnlyTags.push(tag);
      } else {
        editableTags.push(tag);
      }
      //if the 'resolved' tags has already been applied, don't show the Tag as Resolved
      if (tag === "resolved") {
        showTagAsResolved = false;
      }
    });
  }
  if (readOnlyTags.length !== 0 || message.customerData) {
    showExtraInfo = true;
  }
  message.conversationState.showExtraInfo = showExtraInfo;
  message.extraInfoTags = formatReadOnlyTags(message, readOnlyTags);
  message.readOnlyTags = readOnlyTags;
  message.editableTags = editableTags;
  message.conversationState.showTagAsResolved = showTagAsResolved;
};

/**
 * Takes an array of tags and formats them to match the customerData structure
 *
 * @param {array} readOnlyTags
 */
const formatReadOnlyTags = (message, readOnlyTags) => {
  let formattedTags = [];
  if (readOnlyTags.length !== 0) {
    formattedTags = {
      "CRM Tags": {}
    };
    readOnlyTags.map((readOnlyTagsItem, key) => {
      formattedTags["CRM Tags"][`Meta Tag${key + 1}`] = readOnlyTagsItem;
    });
  }
  return formattedTags;
};
const calculatePassButtonDisplayRules = message => {
  const INVALID_PASS_STATES = {
    [REPORTED]: REPORTED,
    [FORWARDED]: FORWARDED,
    [RESPONDED]: RESPONDED,
    [REVIEWED]: REVIEWED,
    [CLAIMED_FOR_REVIEW]: CLAIMED_FOR_REVIEW,
    [CLAIMED_FOR_RESPONSE]: CLAIMED_FOR_RESPONSE,
    [CLAIMED_FOR_RESPONSE_DURING_REVIEW]: CLAIMED_FOR_RESPONSE_DURING_REVIEW,
    [CLAIMED_FOR_FORWARD_REVIEW]: CLAIMED_FOR_FORWARD_REVIEW,
    [DISAGREED]: DISAGREED,
    [CLAIMED_FOR_REVIEW_DETAILED]: CLAIMED_FOR_REVIEW_DETAILED
  };
  message.conversationState.allowPass = INVALID_PASS_STATES[message.conversationState.state] ? false : true;
  if (!message.inbox) {
    message.conversationState.allowPass = false;
  }
};

/**
 * Calculates whether or not to show and capture a 'note' field
 *
 * @param {object} message
 */
const calculateDialogueNote = message => {
  let showDialogueNoteCapture = false;
  let isDialogueNoteCaptureMandatory = false;
  switch (message.dialogueNoteUIControl) {
    case "not_req":
      showDialogueNoteCapture = false;
      break;
    case "cap_man":
      showDialogueNoteCapture = true;
      isDialogueNoteCaptureMandatory = true;
      break;
    case "cap_opt":
      showDialogueNoteCapture = true;
      break;
  }
  message.conversationState.editorState.showDialogueNoteCapture = showDialogueNoteCapture;
  message.conversationState.editorState.isDialogueNoteCaptureMandatory = isDialogueNoteCaptureMandatory;
};

/**
 * Calculates whether or not to show and capture an expert preference
 *
 * @param {object} message
 */
const calculateExpertPrefCapture = message => {
  let showExpertPrefCapture = false;
  let isExpertPrefCaptureMandatory = false;
  switch (message.expertPrefUIControl) {
    case "not_req":
      showExpertPrefCapture = false;
      break;
    case "cap_man":
      showExpertPrefCapture = true;
      isExpertPrefCaptureMandatory = true;
      break;
    case "cap_opt":
      showExpertPrefCapture = true;
      break;
  }
  message.conversationState.editorState.showExpertPrefCapture = showExpertPrefCapture;
  message.conversationState.editorState.isExpertPrefCaptureMandatory = isExpertPrefCaptureMandatory;
};
const calculateShowCustomerAuthor = message => {
  let showCustomerAuthor = true;
  if (message.viewCustAuth === false) {
    showCustomerAuthor = false;
  }
  message.conversationState.showCustomerAuthor = showCustomerAuthor;
};

/**
 * For message editing determing the allow attachments state
 *
 * @param {object} message
 */
const calculateAllowAttachments = message => {
  const VALID_ATTACHMENT_STATES = [CLAIMED_FOR_RESPONSE, RESPOND_AS_MANAGER, CLAIMED_FOR_RESPONSE_DURING_REVIEW];
  if (message.enableAttachment) {
    message.conversationState.allowAttachments = VALID_ATTACHMENT_STATES.includes(message.conversationState.state);
    //expert web app users can't sent attachments as a customer
    message.conversationState.showChooseAttachmentOption = false;
    message.conversationState.attachmentOption = "expert";
  }
};

/**
 * For message editing determing the allow secure data request state
 *
 * @param {object} message
 * @param {object} profile
 */
const calculateAllowSecureDataRequest = (message, profile) => {
  var _message$messageConfi, _message$messageConfi2;
  if (((_message$messageConfi = message.messageConfig) === null || _message$messageConfi === void 0 ? void 0 : (_message$messageConfi2 = _message$messageConfi.secureDataOptions) === null || _message$messageConfi2 === void 0 ? void 0 : _message$messageConfi2.length) > 0 && doesUserHavePolicy(POLICY_SENSITIVE_DATA_REQUEST_ACCESS, profile)) {
    message.conversationState.allowSecureDataRequest = true;
  }
};

/**
 * To indicate whether a message contains a translated customer dialogue
 *
 * @param {object} message
 */
const calculateMessageContainsTranslation = message => {
  message.dialogues.map(dialogue => {
    if (dialogue.origin === "customer" && dialogue.translatedFrom) {
      message.conversationState.isTranslated = true;
    }
  });
};

/**
 * To indicate whether a message contains a translated customer first dialogue locale
 *
 * @param {object} message
 */
const calculateMessageContainsTranslatedLanguage = message => {
  var _message$dialogues$;
  if ((_message$dialogues$ = message.dialogues[0]) !== null && _message$dialogues$ !== void 0 && _message$dialogues$.locale && message.conversationState.isTranslated) {
    message.conversationState.showTransaltedLanguageText = true;
  }
};

/**
 * Calculate whether to capture the product code during Response Preview
 *
 * @param {object} message
 */
const calculateProductCodes = message => {
  let showProductCodes = false;
  let isProductCodeMandatory = false;
  switch (message.msgClassificationUIControl) {
    case "not_req":
      showProductCodes = false;
      break;
    case "cap_man":
      showProductCodes = true;
      isProductCodeMandatory = true;
      break;
    case "cap_opt":
      showProductCodes = true;
      break;
  }
  const {
    msgClassificationMetaData
  } = message;
  if (showProductCodes) {
    if (!msgClassificationMetaData || Object.keys(msgClassificationMetaData).length === 0 || msgClassificationMetaData.classificationCode === null) {
      showProductCodes = false;
    }
  }
  message.conversationState.editorState.showProductCodes = showProductCodes;
  message.conversationState.editorState.isProductCodeMandatory = isProductCodeMandatory;
};
const calculateConversationType = message => {
  message.conversationState.type = "respond";
  if (isMessageReviewState(message.conversationState.state)) {
    message.conversationState.type = message.inbox.type;
  }
};
const calculateExpertTouchedMessage = (message, userId) => {
  const {
    lastDialogue
  } = getLastDialogue(message);
  // handle the scenario where you refresh the screen, had the claim and had submitted dialogue
  if (lastDialogue && lastDialogue.userId && lastDialogue.userId === userId && lastDialogue.origin !== "thirdparty") {
    message.hasExpertTouched = true;
    message.isLastCustomerDialogue = false;
  }
};
const calculateClientActionDialogue = (message, nextStateOverride) => {
  if (message.dialogues) {
    if (!nextStateOverride) {
      var _message$inbox3;
      const newDialogues = [...message.dialogues];
      const isClaimed = (_message$inbox3 = message.inbox) === null || _message$inbox3 === void 0 ? void 0 : _message$inbox3.claimed;
      newDialogues.map(d => {
        if (d.type === "client-action-type") {
          if (!isClaimed) {
            message.conversationState.originalState = message.conversationState.state;
            message.conversationState.state = RESPOND_CLIENT_ACTION;
            d.hidden = true;
          } else {
            message.conversationState.originalState = message.conversationState.state;
            message.conversationState.state = CLAIMED_CLIENT_ACTION;
            d.hidden = false;
          }
        } else {
          d.hidden = false;
        }
      });
      message.dialogues = newDialogues;
    }
  }
};

/**
 * Calculate whether to hide the editor
 *
 * @param {object} message
 */
const calculateHideEditor = message => {
  let hideEditor = false;
  switch (message.replyUIControl) {
    case "not_req":
      hideEditor = true;
      break;
    case "cap_man":
      hideEditor = false;
      break;
  }
  message.conversationState.hideEditor = hideEditor;
  //they can add dialogue but might want to submit classification data
  if (hideEditor) {
    message.hasAddedDialogue = true;
  }
};

/**
 * For message editing determing the allow secure data request state
 *
 * @param {object} message
 * @param {object} profile
 */
const calculateAllowSecureDataView = (message, profile) => {
  if (doesUserHavePolicy(POLICY_SENSITIVE_DATA_VIEW_ACCESS, profile)) {
    message.conversationState.allowSecureDataView = true;
  }
};